export const US_STATES: { label: string; value: string }[] = [
  { label: 'Alaska', value: 'AK' },
  { label: 'Alabama', value: 'AL' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'District of Columbia', value: 'DC' },
  { label: 'Delaware', value: 'DE' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Maine', value: 'ME' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Montana', value: 'MT' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New York', value: 'NY' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Washington', value: 'WA' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wyoming', value: 'WY' },
];

export const STATE_LABEL_BY_CODE: Record<string, string> = US_STATES.reduce(
  (acc, s) => { acc[s.value] = s.label; return acc; }, {} as Record<string, string>,
);

export interface FeeEntry { state: string; record_type: string; cost: number; effective_date?: string; }

export const FEE_LIST: FeeEntry[] = [
  { state: 'Alabama', record_type: '3Y', cost: 10.00 },
  { state: 'Alaska', record_type: '3Y', cost: 10.00 },
  { state: 'Arizona', record_type: '5Y (instant)', cost: 8.00 },
  { state: 'Arizona', record_type: '3Y (instant)', cost: 6.00 },
  { state: 'Arizona', record_type: '3Y (overnight)', cost: 5.00 },
  { state: 'Arizona', record_type: 'EM', cost: 6.00 },
  { state: 'Arkansas', record_type: 'EM (commercial)', cost: 14.20, effective_date: '08/01/2024' },
  { state: 'Arkansas', record_type: '3Y (standard)', cost: 12.70, effective_date: '08/01/2024' },
  { state: 'California', record_type: '3Y', cost: 2.00 },
  { state: 'California', record_type: 'EPN Enrollment', cost: 5.00 },
  { state: 'Colorado', record_type: '7Y', cost: 6.00, effective_date: '01/01/2024' },
  { state: 'Connecticut', record_type: '3Y', cost: 18.00 },
  { state: 'Delaware', record_type: '3Y', cost: 25.00 },
  { state: 'District of Columbia', record_type: '3Y', cost: 13.00 },
  { state: 'Florida', record_type: '7Y (commercial)', cost: 10.02 },
  { state: 'Florida', record_type: '3Y', cost: 8.02 },
  { state: 'Georgia', record_type: '7Y', cost: 8.00 },
  { state: 'Georgia', record_type: '3Y', cost: 6.00 },
  { state: 'Hawaii', record_type: '3Y (overnight)', cost: 23.00 },
  { state: 'Idaho', record_type: '3Y', cost: 10.00, effective_date: '07/01/2023' },
  { state: 'Illinois', record_type: '3Y', cost: 20.00, effective_date: '07/01/2023' },
  { state: 'Indiana', record_type: '3Y', cost: 10.00, effective_date: '12/01/2021' },
  { state: 'Iowa', record_type: '3Y', cost: 10.30, effective_date: '02/01/2020' },
  { state: 'Kansas', record_type: '3Y', cost: 16.70, effective_date: '11/01/2020' },
  { state: 'Kentucky', record_type: '3Y', cost: 6.00, effective_date: '01/01/2023' },
  { state: 'Louisiana', record_type: 'EM', cost: 18.00 },
  { state: 'Louisiana', record_type: '3Y', cost: 18.00 },
  { state: 'Maine', record_type: '7Y', cost: 12.00 },
  { state: 'Maine', record_type: '3Y', cost: 7.00 },
  { state: 'Maryland', record_type: '3Y', cost: 15.00, effective_date: '09/01/2024' },
  { state: 'Massachusetts', record_type: '3Y', cost: 8.00 },
  { state: 'Michigan', record_type: 'EM', cost: 15.00 },
  { state: 'Michigan', record_type: '3Y', cost: 15.00 },
  { state: 'Minnesota', record_type: '7Y', cost: 5.00, effective_date: '10/01/2023' },
  { state: 'Minnesota', record_type: '3Y', cost: 5.00 },
  { state: 'Mississippi', record_type: '3Y', cost: 14.00 },
  { state: 'Missouri', record_type: 'DB', cost: 5.80 },
  { state: 'Missouri', record_type: '3Y (overnight)', cost: 0.12 },
  { state: 'Montana', record_type: '3Y', cost: 7.87, effective_date: '10/01/2020' },
  { state: 'Nebraska', record_type: '3Y', cost: 7.50, effective_date: '07/01/2021' },
  { state: 'Nevada', record_type: '3Y', cost: 7.00 },
  { state: 'New Hampshire', record_type: '3Y', cost: 17.00, effective_date: '07/01/2023' },
  { state: 'New Jersey', record_type: '5Y', cost: 12.00 },
  { state: 'New Mexico', record_type: '3Y', cost: 6.50 },
  { state: 'New York', record_type: '3Y', cost: 7.00 },
  { state: 'North Carolina', record_type: '7Y', cost: 12.75, effective_date: '07/01/2024' },
  { state: 'North Carolina', record_type: '3Y', cost: 12.75, effective_date: '07/01/2024' },
  { state: 'North Dakota', record_type: '3Y', cost: 3.00 },
  { state: 'Ohio', record_type: '3Y', cost: 5.00 },
  { state: 'Oklahoma', record_type: '3Y', cost: 27.50 },
  { state: 'Oregon', record_type: 'EM', cost: 13.99, effective_date: '07/01/2023' },
  { state: 'Oregon', record_type: '3Y', cost: 13.99, effective_date: '07/01/2023' },
  { state: 'Oregon', record_type: 'CR', cost: 13.99, effective_date: '07/01/2023' },
  { state: 'Pennsylvania', record_type: 'EM', cost: 16.00, effective_date: '07/01/2023' },
  { state: 'Pennsylvania', record_type: '3Y', cost: 16.00, effective_date: '07/01/2023' },
  { state: 'Rhode Island', record_type: '3Y', cost: 21.00, effective_date: '07/01/2020' },
  { state: 'South Carolina', record_type: '7Y', cost: 7.25 },
  { state: 'South Dakota', record_type: '3Y', cost: 5.00 },
  { state: 'Tennessee', record_type: '3Y', cost: 7.50 },
  { state: 'Texas', record_type: 'EM (commercial)', cost: 7.50 },
  { state: 'Texas', record_type: '3Y', cost: 6.50 },
  { state: 'Utah', record_type: 'EM (commercial)', cost: 11.00, effective_date: '07/01/2018' },
  { state: 'Utah', record_type: '3Y', cost: 11.00 },
  { state: 'Vermont', record_type: '3Y', cost: 21.00, effective_date: '01/01/2024' },
  { state: 'Virginia', record_type: '3Y', cost: 8.00 },
  { state: 'Washington', record_type: '5Y', cost: 15.00, effective_date: '10/01/2022' },
  { state: 'West Virginia', record_type: '3Y', cost: 12.50 },
  { state: 'Wisconsin', record_type: '5Y', cost: 7.00 },
  { state: 'Wyoming', record_type: 'EM', cost: 10.00, effective_date: '02/01/2024' },
  { state: 'Wyoming', record_type: '3Y', cost: 10.00, effective_date: '02/01/2024' },
];

export interface DriverRow {
  id?: string;
  databaseId?: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  licenseNumber?: string;
  licenseState?: string;
  dateOfBirth?: string;
  gender?: string;
  state?: string;
  addressLine1?: string;
  city?: string;
  zipCode?: string;
  active?: boolean;
}
